interface ProgressBarProps {
  value: number
  max?: number
  label?: string
  showPercent?: boolean
}

export default function ProgressBar({ value, max = 100, label, showPercent = true }: ProgressBarProps) {
  const percent = Math.round((value / max) * 100)
  return (
    <div>
      {label && (
        <div className="flex justify-between text-xs text-gray-400 mb-1">
          <span>{label}</span>
          {showPercent && <span>{percent}%</span>}
        </div>
      )}
      <div className="h-2 bg-vertex-surface rounded-full overflow-hidden">
        <div
          className="h-full bg-gradient-to-l from-vertex-gold to-vertex-gold-dark rounded-full transition-all duration-500"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  )
}
